import basic from '@com/lang/zh/basic'
import locale from './locales/zh-cn.json'
import resourceManager from '@com/lang/zh/resourceManager'
import workbench from '@com/lang/zh/workbench'
import exportHistory from '@pt/lang/zh/exportHistory'
import whole from '@pt/lang/zh/whole'
import videoProject from '@pt/lang/zh/videoProject'
import assetLibrary from '@pt/lang/zh/assetLibrary'
import taskCenter from '@pt/lang/zh/taskCenter'
import cropperDialog from '@/lang/zh/cropperDialog'
import playableProject from '@pt/lang/zh/playableProject'
import templateLibrary from '@pt/lang/zh/templateLibrary'
import dashboard from '@pt/lang/zh/dashboard'
import home from '@pt/lang/zh/home'
import login from '@pt/lang/zh/login'
import voiceLab from '@pt/lang/zh/voiceLab'

export default {
  basic,
  resourceManager,
  cropperDialog,
  workbench: {
    ...workbench,
  },
  playTurbo: {
    exportHistory,
    videoProject,
    assetLibrary,
    whole,
    taskCenter,
    playableProject,
    templateLibrary,
    dashboard,
    home,
    login,
    voiceLab,
  },
  ...locale,
}
